export class ReadtsValue {
   readts? : Array<Date>;
   value? : Array<number>;
   labels? : string[];
}